import { getContext } from 'svelte';
import { writeContract } from '@wagmi/core';
import { get } from 'svelte/store';
import { ContextStateSymbol } from '../context';
export function useWriteContract() {
    const { config } = getContext(ContextStateSymbol);
    const configFromStore = get(config);
    return (parameters) => writeContract(configFromStore, parameters);
}
